var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModernBuildings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 46.5V12C4.49961 11.7293 4.5727 11.4635 4.71148 11.231C4.85025 10.9986 5.04951 10.8081 5.288 10.68L21.788 1.79999C22.0162 1.67693 22.2724 1.61511 22.5316 1.62057C22.7908 1.62603 23.0441 1.69857 23.2669 1.83113C23.4898 1.96369 23.6744 2.15173 23.8029 2.37691C23.9314 2.6021 23.9993 2.85674 24 3.11599V46.5",
    stroke: "#001145",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 46.5V26.166C43.4999 25.9375 43.4476 25.7121 43.3471 25.5069C43.2465 25.3017 43.1005 25.1222 42.92 24.982L32.42 16.816C32.1986 16.6431 31.933 16.5359 31.6535 16.5068C31.3741 16.4776 31.092 16.5276 30.8397 16.6511C30.5873 16.7746 30.3747 16.9665 30.2262 17.205C30.0778 17.4436 29.9994 17.7191 30 18V46.5",
    stroke: "#001145",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 46.5H1.5",
    stroke: "#001145",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 16.5H15",
    stroke: "#001145",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24 22.5H12",
    stroke: "#001145",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 46.5H18V40.5C18 39.7044 17.6839 38.9413 17.1213 38.3787C16.5587 37.8161 15.7956 37.5 15 37.5C14.2044 37.5 13.4413 37.8161 12.8787 38.3787C12.3161 38.9413 12 39.7044 12 40.5V46.5Z",
    stroke: "#001145",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9 8.68V1.5",
    stroke: "#001145",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30 27H34.5",
    stroke: "#001145",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30 33H37.5",
    stroke: "#001145",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 23.1V16.5",
    stroke: "#001145",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModernBuildings);
export default __webpack_public_path__ + "static/media/modern_buildings.5a4aff815845c92ebfad4f00ff426969.svg";
export { ForwardRef as ReactComponent };